import { Check, Edit, Star, Trash2, MoreVertical, Move } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator, DropdownMenuLabel } from "@/components/ui/dropdown-menu";
import { DEFAULT_DOMAINS } from "./constants";

const TaskCard = ({ 
  task, 
  domainKey,
  domainTasks,
  isDragging,
  isDropTarget,
  onComplete,
  onEdit,
  onDelete,
  onTogglePriority,
  onMove,
  onDragStart,
  onDragEnd,
  onDragOver,
  onDrop
}) => {
  return (
    <div 
      className={`group p-3 rounded-xl border transition-all cursor-grab active:cursor-grabbing ${
        task.is_completed ? 'bg-gray-50 opacity-60' : 'bg-white'
      } ${isDragging ? 'opacity-50 scale-95 border-indigo-400' : 'hover:shadow-md'} ${
        isDropTarget ? 'border-2 border-indigo-500 bg-indigo-50' : 'border-gray-100'
      }`}
      draggable="true"
      onDragStart={(e) => onDragStart(e, task, domainKey)}
      onDragEnd={onDragEnd}
      onDragOver={(e) => onDragOver(e, task.task_id)}
      onDrop={(e) => onDrop(e, task, domainKey, domainTasks)}
    >
      <div className="flex items-start gap-2">
        <div className="cursor-grab active:cursor-grabbing p-1 -ml-1 text-gray-300 hover:text-gray-500">
          <Move className="w-3 h-3" />
        </div>
        
        <button
          onClick={() => task.is_completed ? null : onComplete(task.task_id)}
          className={`w-4 h-4 mt-0.5 rounded border-2 flex-shrink-0 flex items-center justify-center ${
            task.is_completed 
              ? 'bg-green-500 border-green-500 text-white' 
              : 'border-gray-300 hover:border-green-500 hover:bg-green-50'
          }`}
        >
          {task.is_completed && <Check className="w-2.5 h-2.5" />}
        </button>
        
        <div className="flex-1 min-w-0">
          <p className={`text-sm font-medium leading-tight ${
            task.is_completed ? 'line-through text-gray-400' : 'text-gray-800'
          }`}>
            {task.title}
          </p>
          <div className="flex items-center gap-1.5 mt-1 flex-wrap">
            {task.due_date && (
              <span className="text-[10px] text-gray-400 bg-gray-50 rounded-full px-1.5 py-0.5">
                {new Date(task.due_date).toLocaleDateString("it-IT", { day: "numeric", month: "short" })}
              </span>
            )}
            {task.is_urgent && (
              <span className="text-[10px] bg-red-100 text-red-600 rounded-full px-1.5 py-0.5">Urgente</span>
            )}
          </div>
        </div>
        
        <button
          onClick={() => onTogglePriority(task)}
          className={`p-1 rounded transition-all ${
            task.is_priority 
              ? 'text-amber-500' 
              : 'text-gray-300 hover:text-amber-400 opacity-0 group-hover:opacity-100'
          }`}
        >
          <Star className={`w-3.5 h-3.5 ${task.is_priority ? 'fill-amber-500' : ''}`} />
        </button>
        
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="p-1 text-gray-400 hover:text-gray-600 opacity-0 group-hover:opacity-100">
              <MoreVertical className="w-3.5 h-3.5" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-40 rounded-xl">
            <DropdownMenuItem onClick={() => onEdit(task)} className="cursor-pointer rounded-lg text-sm">
              <Edit className="w-3 h-3 mr-2" /> Modifica
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuLabel className="text-xs text-gray-400">Sposta in:</DropdownMenuLabel>
            {Object.entries(DEFAULT_DOMAINS).filter(([k]) => k !== task.domain).slice(0, 4).map(([key, config]) => (
              <DropdownMenuItem key={key} onClick={() => onMove(task.task_id, key, "")} className="cursor-pointer rounded-lg text-xs">
                {config.emoji} {config.label}
              </DropdownMenuItem>
            ))}
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => onDelete(task.task_id)} className="cursor-pointer rounded-lg text-sm text-red-600">
              <Trash2 className="w-3 h-3 mr-2" /> Elimina
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};

export default TaskCard;
